import { EmptyViewWrapper } from '../../components';
import type { SecondFactorSubmission } from '../onboarding/hooks/useSignInForm.utils';
import { SecondFactorView } from '../onboarding/views/sign-in-up/SecondFactorView';

type VerifyTokenSecondFactorViewProps = {
  returnToDefault: () => void;
  submitSecondFactor: (input: SecondFactorSubmission) => Promise<void>;
};

export const VerifyTokenSecondFactorView = ({
  returnToDefault,
  submitSecondFactor,
}: VerifyTokenSecondFactorViewProps) => {
  return (
    <EmptyViewWrapper
      title="2FA Authentication"
      actions={
        <SecondFactorView
          submitSecondFactor={submitSecondFactor}
          returnToDefault={returnToDefault}
        />
      }
    />
  );
};
